import { Button, Pagination, Table } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import Icon from '../../../components/Icon/Icon';
import Spinner from '../../../components/Spinner/Spinner';
import Tag from '../../../components/Tag/Tag';
import ErrorMessage from '../../../components/ErrorMessage/ErrorMessage';

import useUsersTab, { pageSize } from './useUsersTab';
import { Role } from '../../../Helpers/AuthorizationDataProvider';

import { TabStatus, TableData } from './UsersTab.model';

import styles from './UsersTab.module.scss';

const UsersTab = (props: any) => {
	const {
		getUsers,
		reinviteUser,
		state,
		onChangeUsersPagination,
	} = useUsersTab(props);
	const {
		tabStatus,
		users,
		usersPagination
	} = state;

	const history = useHistory()
	const intl = useIntl();

	const getTagColorByRole = (role: Role) => {
		switch (role) {
			case 'Mentee': return 'grey';
			case 'Mentor': return 'blue';
			case 'Admin': return 'red';
		}
	};
	const columnsUsers = [
		{
			className: styles.linkCell,
			dataIndex: 'name',
			render: (text: string, record: TableData) => (<>
				<div className={styles.avatar}>
					<Icon
						color="light"
						height="12px"
						name="user"
						width="12px"
					/>
				</div>
				{text}
				{!record.isActive && <Button
					className={styles.tableButton}
					onClick={event => { event.stopPropagation(); reinviteUser(record.id);}}
					type="ghost"
					>
						<FormattedMessage id="buttons.reinviteUser"/>
				</Button>}
			</>),
			title: intl.formatMessage({ id: 'table.column.name' }),
		},
		{
			dataIndex: 'location',
			title: intl.formatMessage({ id: 'table.column.location' }),
		},
		{
			dataIndex: 'userType',
			render: (role: Role) => (
				<Tag
					color={getTagColorByRole(role)}
				>
					<FormattedMessage id={`role.${role}`}/>
				</Tag>
			),
			title: intl.formatMessage({ id: 'table.column.userType' }),
		},
	];

	const onUserRow = (rowData: TableData) => {
    return {
			onClick: () => {
				history.push(`/users/${rowData.id}`);
			},
    };
  }

	return (
		<div className={styles.tabContent}>
			<Spinner spinning={tabStatus === TabStatus.Loading} />
			<ErrorMessage error={tabStatus === TabStatus.Error} onRefresh={getUsers} showReport={false}/>
			<div className={styles.table}>
				<Table
					columns={columnsUsers}
					dataSource={users}
					pagination={false}
					onRow={onUserRow}
					rowKey={(rowData: TableData) => rowData.id}
				/>
			</div>
			<div className={styles.contentMobile}>
				{users.map((user, key) =>
				<div className={styles.container} key={key} onClick={() => history.push(`/users/${user.id}`)}>
					<div className={styles.wrapper}>
						<div className={styles.userInfo}>
						<div className={styles.iconContainer}>
							{user?.imageId ? (
								<img alt="" src={user?.imageId} className={styles.avatar} />
							) : (
								<div className={styles.avatar}>
									<Icon color="text" height="12px" name="user" width="12px" />
								</div>
							)}
						</div>
						<div className={styles.userContainer}>
							<span>{user.name}</span>
							<div className={styles.location}>
								<span>{user.location}</span>
							</div>
							
						</div>
					</div>
						<div>
							<Tag
								color={getTagColorByRole(user?.userType)}
							>
								{user?.userType}
							</Tag>
						</div>
					</div>
					<div className={styles.actions}>
							{!user.isActive && <Button
								className={styles.tableButton}
								onClick={event => { event.stopPropagation(); reinviteUser(user.id);}}
								type="ghost"
							>
								<FormattedMessage id="buttons.reinviteUser"/>
							</Button>}
					</div>
				</div>
				)}
			</div>
			<div className={styles.paginationWrapper}>
				<Pagination
					current={usersPagination.page}
					pageSize={pageSize}
					total={usersPagination.total}
					onChange={onChangeUsersPagination}
					showSizeChanger={false}
				/>
			</div>
		</div>
	);
};

export default UsersTab;